<template>
  <el-dialog
    :visible.sync="visible"
    :title="finished ? 'Calcul terminé' : 'Calcul en cours…'"
    :close-on-click-modal="false"
    width="500px">

    <el-progress :percentage="percentage" :status="progressStatus"></el-progress>

    <div class="mt-3 text-center">
      <strong>{{ done }} / {{ total }}</strong> recettes traitées
    </div>

    <div class="mt-2 text-center">
      <span class="text-success mr-3">✓ {{ success }} réussies</span>
      <span class="text-danger">✗ {{ error }} erreurs</span>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">
        {{ finished ? 'Fermer' : 'Fermer (continue en fond)' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      batchId: null,
      total: 0,
      success: 0,
      error: 0,
      done: 0,
      pollTimer: null,
    };
  },
  computed: {
    percentage() {
      return this.total ? Math.round((this.done / this.total) * 100) : 0;
    },
    finished() {
      return this.total > 0 && this.done >= this.total;
    },
    progressStatus() {
      if (this.finished && this.error > 0) return 'warning';
      if (this.finished) return 'success';
      return null;
    },
  },
  watch: {
    finished(val) {
      if (val) {
        this.stopPolling();
        this.$emit('finished', { success: this.success, error: this.error, total: this.total });
      }
    },
  },
  methods: {
    open(batchId, total) {
      this.batchId = batchId;
      this.total = total;
      this.success = 0;
      this.error = 0;
      this.done = 0;
      this.visible = true;
      this.fetchProgress();
      this.pollTimer = setInterval(this.fetchProgress, 2500);
    },
    async fetchProgress() {
      try {
        const { data } = await axios.get('/pro/recipes/calcul/progress/' + this.batchId);
        this.success = data.success;
        this.error = data.error;
        this.done = data.done;
        this.total = data.total;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.done = this.total;
          this.success = this.total;
        }
        this.stopPolling();
      }
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
